/* HACK: https://github.com/ReactTraining/react-router/issues/5072#issuecomment-316953879 */
import { Route, Redirect } from "react-router-dom"
import { connect } from "react-redux"

const addLocation = connect(({ router }) => ({
  location: router.location,
}))

export const ConnectedRoute = addLocation(Route)
export const ConnectedRedirect = addLocation(Redirect)
